<!--
 * @Author: cmchiu
 * @Date: 2022-06-27 16:48:32
 * @LastEditTime: 2023-06-29 10:33:59
 * @LastEditors: cmchiu
 * @Description: 
 * @FilePath: \campus2022\campus2022-ClientApp\src\components\CalendarList\calendarlist.vue
 * 
-->
<template>
    <div class="calendar-ls">
        <ul>
            <li v-for="item in events" :key="item.index" v-show="item.events.length > 0">
                <div class="calender_date" v-html="item.date + ' ' + item.week"></div>
                <div v-for="event in item.events" :key="event.index" class="display-flex">
                    <div class="calender_bg"></div>
                    <div class="calender_event">
                        {{ event.title }}
                    </div>
                </div>
            </li>
        </ul>
    </div>
</template>

<script>
import XEUtils from 'xe-utils'
import { getRangeEvents } from '@/api/campus'
import { isDateBetween } from '@/utils/common'

export default {
    name: 'calendarLs',

    props: {
        datas: {
            type: [String, Array, Object],
            default: null,
        },
    },

    data: function () {
        return {
            list: this.datas,
            events: [],
            rangeDays: 29, //查詢最近30天內的事件 (計算時會加上今天, 所以設定的天數要扣1天)
        }
    },

    created: function () {
        this.getRangeEvents()
    },

    methods: {
        async getRangeEvents() {
            let now = XEUtils.now()
            let events = []
            let params = {
                sdate: XEUtils.toDateString(now, 'yyyy-MM-dd'),
                edate: XEUtils.toDateString(now + 864e5 * this.rangeDays, 'yyyy-MM-dd'),
            }
            await getRangeEvents(params).then(res => {
                if (res.Code === 1) {
                    XEUtils.arrayEach(res.Items, item => {
                        let endDate = new Date(item.EndDate)
                        let endDate_AllDay = endDate.setTime(endDate.getTime() + 1000 * 60 * 60 * 24) // 結束日期補滿24小時
                        let event = {
                            id: item.BoardID,
                            title: item.TitleC,
                            start: XEUtils.toDateString(item.StartDate, 'yyyy-MM-dd'),
                            end: XEUtils.toDateString(endDate_AllDay, 'yyyy-MM-dd'),
                        }

                        events.push(event)
                    })
                }
            })

            let sevenDays = []
            let week = [
                '<span class="sunday">週日</span>',
                '週一',
                '週二',
                '週三',
                '週四',
                '週五',
                '<span class="saturday">週六</span>',
            ]
            for (let d = 0; d <= this.rangeDays; d++) {
                let date = now + 864e5 * d
                let day = {
                    date: XEUtils.toDateString(date, 'yyyy年MM月dd日'),
                    week: week[Number(XEUtils.toDateString(date, 'E'))],
                    events: [],
                }
                XEUtils.arrayEach(events, item => {
                    if (isDateBetween(date, item.start, item.end)) {
                        day.events.push({ title: item.title })
                    }
                })
                sevenDays.push(day)
            }

            this.events = sevenDays
        },
    },
}
</script>

<style scoped></style>
